module.exports = __webpack_public_path__ + "static/media/cradle_demo_v4.acefda7f.gif";